var AppSetupComponent = new JS.Class(EditorComponent, {
  initialize: function(appSetupSelector) {
    this.appSetup = $(appSetupSelector);

    this._config = null;
  },

  getSaveData: function() {
    var setup = {
      appId: this.appSetup.find('#appId').val(),
      hasConfig: this.appSetup.find('#hasConfig:checked').length ? '1' : '0',
    };

    return {
      AppSetup: setup,
    };
  },
});
